import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import Loader from './../../shared/loader'
import CryptoJS from 'crypto-js'
import download from 'downloadjs'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'ProductLogReport',
	components: {
		Paginate,
		DatePicker,
		Pagination,
		JsonExcel,
		Loader
	},
	data() {
		return {
			// totalRows:0,
			// currentPage: 0,
			isLoadingforxls: false,
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			transactiontypeArr: [],
			productlogData: [],
			productlogDatacsv: [],
			modalShow: false,
			modalMessageShow: false,
			displayMsg: false,
			successErrorMsg: "",
			fromDateFlt: "",
			toDateFlt: "",
			// totalPage: 0,
			// pageNo: 0,
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			listClientData: [],
			listWarehouseData: [],
			clientid: '',
			client: '',
			warehouseid: '',
			warehouse: '',
			ClientErr: '',
			WarehouseErr: '',
			productidErr: '',
			Transactiontype: '',
			rackidErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			orderCancelShow: false,
			loginuserid: '',
			isLoading: false,
			perPage: 10,
			formattedDate: '',
			user_type: '',
			showAuditDetails: false,
			AuditSessionData: [],
			productid: '',
			rackid: '',
			resultCount: 0,
			fromdate: '',
			todate: '',
			currentAuditData: [],
			auditDetailsCsv: [],
			logtype: 'product',
			clientproductid: '',
			currentDate: '',
			clientproductidcheck: 0,
			clientproductidErr: '',
			productidError: '',
			productidcheck: 0,
			Statustype: 'active',
			activemrpflag:false,
			virtualTransaction:'',
			transactionReference:''
		}
	},
	filters: {
		moment: function (dates) {
			return moment(dates).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		this.callFunction();
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.reportname = this.$t('editedjson.productLogReport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.clientproductidcheck = 0;
		this.clientproductidErr = '';
		this.productidError = '';
		this.productidcheck = 0;
		this.loginuserid = userdetail.userid;
		this.user_type = userdetail.utype;
		this.pageNo = 0;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if(this.clientid!=='undefined'){
			this.getTransactionType()
		}	

		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getTransactionType()
				this.getActiveMrpFlag();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}

	}, // End computed
	methods: {
		callFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.toDateFlt = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 7);
			this.fromDateFlt = dt;
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			this.getProductLogListingForXLS(3)
		},

		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		updatevalue(logtype) {
			this.logtype = logtype;
			if (logtype == 'product') {
				this.productid = '';
				this.rackid = '';
				this.rackidErr = '';
				document.getElementById("rackid").value = '';
			} else {
				this.rackid = '';
				this.productid = '';
				document.getElementById("productid").value = '';
				this.productidErr = '';
				this.productidError = '';
			}
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		if (this.warehouseid)
		// 			this.input = ({
		// 				warehouseid: this.warehouseid,
		// 			});
		// 		else {
		// 			this.input = {};
		// 		}

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		getTransactionType() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				status: this.Statustype,
				clientid: this.clientid,
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getTransactiontypeList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					// console.log(result.data.data);
					this.transactiontypeArr = result.data.data;
				}, error => {
					console.error(error)
				})

		},
		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.transactiontypeArr = [];
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getTransactionType()
		// 			this.getActiveMrpFlag();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			this.getTransactionType()
		// 			this.getActiveMrpFlag();
		// 		}
		// 	}
		// 	this.productlogData = [];
		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {

		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		async getActiveMrpFlag(){
 				 var userToken = window.localStorage.getItem('userToken');
 				 var myStr = userToken.replace(/"/g, '');
 				 this.input = ({
 					 "clientid": this.clientid,
 				 });
 			 try {

 					 axios({
 							 method: 'POST',
 							 'url': apiUrl.api_url + 'checkActivemrpFlg',
 							 'data': this.input,
 							 headers: {
 								 'Authorization': 'Bearer ' + myStr,
 							 }
 						 })
 						 .then(result => {
 							 if(result.data.data.data[0].value ==='yes'){
 								 this.activemrpflag = true;
 							 }else{
 								 this.activemrpflag = false;
 							 }
 						 }, error => {
 							 console.error(error);
 						 });

 				 } catch (err) {
 					 throw new Error(err);
 				 }
 	 },

		getProductLogListing(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				this.productlogData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.productlogData = [];
				return false;
			}
			if (this.logtype == '') {
				this.$alertify.error(this.$t('productLogReport.selectLogType'));
				this.pageNo = this.totalPage = 0;
				this.productlogData = [];
				return false;
			}
			if (this.logtype == 'product' && this.productid == '') {
				this.productidErr = this.$t('productLogReport.ProductIDError');
				this.pageNo = this.totalPage = 0;
				this.productlogData = [];
				return false;
			} else if (this.productid != '' && this.productid <= 0) {
				this.productidError = "productid must be greator than zero";
				this.productidcheck = 1;
				return false;
			} else {
				this.productidError = '';
				this.productidcheck = 0;
			}
			if (this.logtype == 'rack' && this.rackid == '') {
				this.rackidErr = this.$t('auditReport.rackIDRequired');
				this.pageNo = this.totalPage = 0;
				this.productlogData = [];
				return false;
			}

			this.isLoading = true;

			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				userid: this.loginuserid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				clientid: window.localStorage.getItem('selectedClient') ,
				fromdate: this.dateFormat1(this.fromDateFlt),
				todate: this.dateFormat2(this.toDateFlt),
				productid: this.productid,
				rackid: this.rackid,
				transactiontype: this.Transactiontype,
				csvData: csvCheck,
				clientproductid: this.clientproductid.trim(),
				virtualTransactiontype: this.virtualTransaction,
				transactionReference:this.transactionReference
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getProductLogListing',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						this.show = true;
						this.download = false;
						this.productlogDatacsv = [];
						this.csvFields = {
							'createddatetime': this.$t('receivedEmail.dateandTime'),
							'txnuser': this.$t('editedjson.user'),
							'eancode': this.$t('inwardList.printData.productDetails.eanCode'),
							'rackid':  this.$t('common.rackID'),
							'txnqty': this.$t('editedjson.transactionQunatity'),
							'whcurrentstock':  this.$t('editedjson.resultingCurrentStock'),
							'whrackstock':  this.$t('reports.rackStock'),
							'transactiontype': this.$t('productLogReport.transactionType'),
							'txnsource': this.$t('productLogReport.transactionReference'),
							'mrp': this.$t('common.mrp'),
							'activemrp': this.$t('common.activemrp'),
							'scissueqty':  this.$t('editedjson.scIssueQty'),
							'screceiptqty':  this.$t('editedjson.scReceiptQty'),
							'txntypeid':   this.$t('editedjson.txnTypeID'),
							'racktype': this.$t('common.rackType'),
							'totalcurrentstock': this.$t('editedjson.totalcurrentstock'),
							'totalrackstock':  this.$t('editedjson.totalrackstock'),
						};
						var dateFilter = [];
						if(this.activemrpflag === true){
								var skipFilter = [];
						}else {
								var skipFilter = ['activemrp'];
						}
						this.productlogDatacsv = [];
						this.productlogDatacsv = result.data.data;
						csvHelper.data.jsonToCSV(this.$t('editedjson.productLogReport'), this.productlogDatacsv, this.csvFields, dateFilter, skipFilter, dataFilter);
					} else {
						this.productlogData = result.data.data;
						if (result.data.errorCode == -1) {
							this.resultCount = 0;
							this.$alertify.error(result.data.msg);
						} else {
							this.totalRows = result.data.count
							this.resultCount = result.data.count
							if (this.totalRows < 10) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / 10)
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		getProductLogListingForXLS(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';


			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				userid: this.loginuserid,
				warehouseid:  window.localStorage.getItem('selectedWarehouse'),
				clientid:  window.localStorage.getItem('selectedClient'),
				fromdate: this.dateFormat1(this.fromDateFlt),
				todate: this.dateFormat2(this.toDateFlt),
				transactiontype: this.Transactiontype,
				productid: this.productid,
				rackid: this.rackid,
				csvData: csvCheck,
				clientproductid: this.clientproductid.trim(),
				virtualTransactiontype: this.virtualTransaction,
				transactionReference:this.transactionReference
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getProductLogListing',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls =[];
							this.csvFieldsForXls[this.$t('receivedEmail.dateandTime')] = 'createddatetime';
							this.csvFieldsForXls[this.$t('editedjson.user')] = 'txnuser';
							this.csvFieldsForXls[this.$t('inwardList.printData.productDetails.eanCode')] = 'eancode';
							this.csvFieldsForXls[this.$t('common.rackID')] = 'rackid';
							this.csvFieldsForXls[this.$t('editedjson.transactionQunatity')] = 'txnqty';
							this.csvFieldsForXls[this.$t('editedjson.resultingCurrentStock')] = 'whcurrentstock';
							this.csvFieldsForXls[this.$t('reports.rackStock')] = 'whrackstock';
							this.csvFieldsForXls[this.$t('productLogReport.transactionType')] = 'transactiontype';
							this.csvFieldsForXls[this.$t('productLogReport.transactionReference')] =  'txnsource';
							this.csvFieldsForXls[this.$t('common.mrp')] = 'mrp';
							if(this.activemrpflag === true){
								this.csvFieldsForXls[this.$t('common.activemrp')] = 'activemrp';
							}
							this.csvFieldsForXls[this.$t('editedjson.scIssueQty')] = 'scissueqty';
							this.csvFieldsForXls[this.$t('editedjson.scIssueQty')] = 'screceiptqty';
							this.csvFieldsForXls[this.$t('editedjson.txnTypeID')] =  'txntypeid';
							this.csvFieldsForXls[this.$t('common.rackType')] = 'racktype';


							this.listReportDataforxls = result.data.data;
						}
						else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}


				}, error => {
					console.error(error);
				})
		},
		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.perPage;
		// 	this.getProductLogListing()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getProductLogListing()
		},
		productLogListing() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.resultCount = 0;
			this.searchFlag = true;
			this.productlogData = [];
			this.getProductLogListing(2);
		},
		auditLogSerachReset() {
			this.show = false;
			this.download = true;
			this.ClientErr = "";
			this.clientproductid = "";
			this.fromDateFlt = "";
			this.toDateFlt = "";
			this.productlogData = [];
			this.pageNo = 0;
			this.totalRows = 0;
			this.totalPage = 0;
			this.resultCount = 0;
			this.searchFlag = false;
			this.rackid = '';
			this.productid = '';
			this.logtype = 'product';
			this.Transactiontype = '';
			this.virtualTransaction = '';
			this.transactionReference='';
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
			// this.getProductLogListing();
		},
		onSubmit: function () {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
	} // end methods

}



// WEBPACK FOOTER //
// ./src/views/components/reports/productlogreport/productlogreport.component.js